<template>
  <div class="common-layout">
    <el-container style="min-height: 100vh">
      <!-- <el-header style="padding: 0">
        <el-affix :offset="0">
          <HeaderModule />
        </el-affix>
      </el-header> -->
      <el-main
        style="
          padding: 0;
          margin-top: 0;
          background-color: rgba(245, 247, 250, 0.5);
          height: 100vh;
        "
      >

        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            /* text-align: center; */
            margin-left: auto;
            margin-right: auto;
            width: 80%;
            height: 100vh;
            /* margin-top: 40px;
            margin-bottom: 40px; */
          "
        >
        <div class="title">
          <el-input
            v-model="blogTitle"
            size="large"
            placeholder=""
          >
            <template #prepend>Blog标题</template>
          </el-input>
          <div style="display: flex; flex-direction: row; gap: 10px;">
            <el-upload
              :show-file-list="false"
              class="avatar-uploader"
              :action="uploadAction"
              :on-success="handleSuccess"
              list-type="picture-card"
            >
              <el-image v-if="imageUrl" :src="imageUrl" class="avatar" />
              <el-text v-else class="avatar-uploader-icon" type="primary"><el-icon><Plus /></el-icon>封面图</el-text>
            </el-upload>
          <div>
            <div>
              <el-text size="large" style="color: #000000;"><el-icon><Folder /></el-icon>主标签：</el-text><br/>
              <el-radio-group v-model="radio" @change="handleRadioChange">
                <el-radio-button v-for="tag in tags" :label="tag.tagName" :value="tag.id" :key="tag.id" />
              </el-radio-group>
            </div>
            <div class="demo-button-style">
              <el-text size="large" style="color: #000000;"><el-icon><FolderAdd /></el-icon>副标签：</el-text>
              <el-checkbox-group v-model="checkboxGroup" size="small" :max="maxTagNum">
                <el-checkbox-button v-for="tag in tags" :label="tag.tagName" :value="tag.id" :key="tag.id" :disabled="tag.id === radio"></el-checkbox-button>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        </div>
          <MdEditor
            class="mdEditor"
            @onSave="onSave"
            v-model="text"
            :codeFoldable="false"
            :toolbars="toolbars"
            placeholder="有花堪折直须折，莫待无花空折枝。——杜秋娘（唐代）"
            :maxLength="maxLength"
            :footers="footers"
            @onUploadImg="onUploadImg"
            :showToolbarName="showToolbarName"
          >
            <template #defFooters>
              <span style="color: brown">字数限制{{ maxLength }}</span>
              <span>晨曦暮雪&nbsp;&nbsp;&nbsp;&nbsp;^_^&nbsp;&nbsp;&nbsp;&nbsp;ZG-Blog</span>
            </template>
          </MdEditor>
        </div>
      </el-main>
      <el-footer>
        <FooterModule />
      </el-footer>
    </el-container>
  </div>
  <BackTop />
  <BackGround style="position: absolute; z-index: -1" />
</template>
    
  <script>
import { onMounted,ref } from "vue";
import { MdEditor } from "md-editor-v3";
import "md-editor-v3/lib/style.css";
import { articleSave,uploadImg,findSysTags } from "@/api/api";
import { ElMessage,ElLoading } from 'element-plus'
import { useRouter } from 'vue-router';
import axios from "@/api/axios";
export default {
  components: { MdEditor },
  setup() {

    onMounted(async () => {
      findSysTags()
          .then((response) => {
            tags.value = response.data;
          })
          .catch(() => {
          });
    })
    const router = useRouter();
    const text = ref("");
    const blogTitle = ref("");
    const showToolbarName = ref(true);
    const uploadAction = `${axios.defaults.baseURL}/zg_article/sysHomeImgs/uploadImg`;
    const onSave = (v, h) => {
      h.then((html) => {
        if(blogTitle.value === ''){
          ElMessage.error('请正确填写Blog标题.');
          return
        }
        if(imageUrl.value === ''){
          ElMessage.error('请上传Blog封面图.');
          return
        }
        if(radio.value === ''){
          ElMessage.error('请选择一个Blog主标签.');
          return
        }
        const loading = ElLoading.service({
          lock: true,
          text: '保存中。。。',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        
        const par = {
          title: blogTitle.value,
          picture: imageUrl.value,
          mainTag: radio.value,
          otherTag: checkboxGroup.value.join("|"),
          bodyMd: v,
          bodyHtml: html
        }
        articleSave(par)
          .then((response) => {
            setTimeout(() => {
              const id = response.data;
              loading.close();
              ElMessage({
                message: response.message,
                type: 'success',
              });
              router.push(`/BlogInfo/${id}`)
            }, 2000)
          })
          .catch(() => {
          });
      });
    };
    const onUploadImg = async (files, callback) => {
      const res = await Promise.all(
        files.map((file) => {
          return new Promise((rev, rej) => {
            uploadImg({file:file})
              .then((res) => rev(res))
              .catch((error) => rej(error));
          });
        })
      );

      // 方式一
      callback(res.map((item) => item.data.url));
};
    const toolbars = ref([
      "bold",
      "underline",
      "italic",
      "-",
      "title",
      "strikeThrough",
      "sub",
      "sup",
      "quote",
      "unorderedList",
      "orderedList",
      "task",
      "-",
      "codeRow",
      "code",
      "link",
      "image",
      "table",
      "mermaid",
      "katex",
      "-",
      "revoke",
      "next",
      "save",
      "=",
      "pageFullscreen",
      "preview",
      "catalog",
    ]);
    const footers = ["markdownTotal", 0, "=", 1, "scrollSwitch"];
    const maxLength = ref(20000);

    const imageUrl = ref('')

    const handleSuccess = (response) =>{

      if(response.code != "ZG20000"){
        ElMessage({
              message: response.message,
              type: 'error',
            })
      } else {
        imageUrl.value = response.data.url;
      }
    }

    const maxTagNum = ref(5);
    const tags = ref([])
    const radio = ref('');
    const checkboxGroup = ref([]);
    const handleRadioChange = (value) =>{
      checkboxGroup.value = checkboxGroup.value.filter(v => v !== value);
    }
    return {
      MdEditor,
      text,
      onSave,
      toolbars,
      footers,
      maxLength,
      onUploadImg,
      handleSuccess,
      showToolbarName,
      blogTitle,
      imageUrl,
      maxTagNum,
      radio,
      checkboxGroup,
      tags,
      handleRadioChange,
      uploadAction
    };
  },
};
</script>
    
<style scoped>
.mdEditor{
  height: calc(100vh - 80px);
  box-sizing: border-box;
}
.title{
  box-sizing: border-box;
  width: 100%;
}
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>